/* eslint-disable yola/react/require-default-props */

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MediaPlaceholder from './media-placeholder';
import BackgroundBox from './background-box';
import ScaledIframe from './scaled-iframe';

const types = {
  IMAGE: 'image',
  IFRAME: 'iframe',
};

const MediaPreview = forwardRef(
  (
    {
      url = '',
      type = types.IMAGE,
      backgroundSize = 'cover',
      aspectRatio = '',
      mediaAspectRatio = '',
      placeholderType = null,
      placeholderTitle = '',
      scaledWidth = null,
      displayWidth = null,
      transparent = false,
    },
    ref
  ) => {
    const classes = classNames('ws-media-preview', {
      'ws-media-preview--transparent': transparent,
    });

    const showImage = url && type === types.IMAGE;
    const showIframe = url && type === types.IFRAME;
    const showPlaceholder = !showImage && !showIframe;

    return (
      <div
        ref={ref}
        className={classes}
        {...(aspectRatio && {
          style: {
            aspectRatio,
          },
        })}
      >
        {showImage && <BackgroundBox url={url} size={backgroundSize} />}

        {showIframe && (
          <div className="ws-media-preview__iframe">
            <ScaledIframe
              url={url}
              scaledWidth={scaledWidth}
              displayWidth={displayWidth}
              aspectRatio={Number(mediaAspectRatio) || 1}
            />
          </div>
        )}

        {showPlaceholder && <MediaPlaceholder type={placeholderType} title={placeholderTitle} />}
      </div>
    );
  }
);

MediaPreview.displayName = 'MediaPreview';

MediaPreview.propTypes = {
  url: PropTypes.string,
  type: PropTypes.oneOf(Object.values(types)),
  backgroundSize: PropTypes.oneOf(['cover', 'contain', 'auto']),
  aspectRatio: PropTypes.string,
  mediaAspectRatio: PropTypes.string,
  placeholderType: PropTypes.string,
  placeholderTitle: PropTypes.string,
  scaledWidth: PropTypes.number,
  displayWidth: PropTypes.number,
  transparent: PropTypes.bool,
};

export default MediaPreview;
